import { Component } from "../base/Component";
import { ComponentFactory } from "../../service/ComponentFactory";
import { PageContext } from "../../service/PageContext";

type RelatedItem = {
    title: string;
    url: string;
    posteddate: string;
    engagementtime: number;
    video?: string;
    authors?: string;
    guestname?: string;
    thumb?: string;
};

export class PodcastYouMayAlsoLikeDiscoverability extends Component {
    private static healioUrl = "https://www.healio.com";
    private cleanArticleId: string | undefined;
    private primarySpecialtyName: string | undefined;
    private primarySubSpecialtyId: string | undefined;
    private hwsHost: string | undefined;
    private loaded: boolean | undefined;

    constructor(element: HTMLElement, context: PageContext) {
        super(element, context);
        this.cleanArticleId = this._element.dataset.cleanArticleId;
        this.primarySpecialtyName = this._element.dataset.primarySpecName;
        this.primarySubSpecialtyId = this._element.dataset.primarySubSpecId;
        this.hwsHost = this._element.dataset.hwsHost;
        this.loaded = false;
    }

    public async init(): Promise<void> {
        const component = this;
        $(async () => {
            if (window.Visitor !== undefined && window.Visitor !== "") {
                component.loadRecommendations();
            } else {
                $(window).one("globalsloaded", () => component.loadRecommendations());
                window.setTimeout(() => component.loadRecommendations(), 1500);
            }
        });
    }

    private normalizeUrl(url: string | undefined): string {
        if (!url) return "";
        return url.toString().replace(PodcastYouMayAlsoLikeDiscoverability.healioUrl, "").trim().toLowerCase();
    }

    private getThumbnailUrl(item: RelatedItem): string {
        const thumb = item?.thumb;
        if (!thumb) return "";
        const mediaidindex = thumb.indexOf("mediaid");
        if (mediaidindex > -1) {
            let thumbnailid = thumb.substr(mediaidindex, mediaidindex + 41);
            thumbnailid = thumbnailid.replace('mediaid="{', "").replace('}"', "").replace('"', "").replace(/-/g, "");
            return thumbnailid.length > 1 ? "/~/media/" + thumbnailid + ".png?w=400" : "";
        }
        if (thumb.startsWith("http://") || thumb.startsWith("https://") || thumb.startsWith("/")) return thumb;
        return "";
    }

    private populateCredits(cardElem: HTMLElement, item: RelatedItem): void {
        const credits = cardElem.querySelector(".podcast-episode-card__credits") as HTMLElement;
        const hostItem = cardElem.querySelector(".podcast-episode-card__credit-item--host") as HTMLElement;
        const guestItem = cardElem.querySelector(".podcast-episode-card__credit-item--guest") as HTMLElement;
        const hostValue = hostItem?.querySelector(".value") as HTMLElement;
        const guestValue = guestItem?.querySelector(".value") as HTMLElement;

        let hostText = "";
        let guestText = "";
        const authorsRaw = (item?.authors || "").trim();
        if (authorsRaw) {
            const splitAuthors = authorsRaw.split("|");
            hostText = (splitAuthors[0] || "").trim();
            guestText = (splitAuthors[1] || "").trim();
        }
        if (!guestText && item?.guestname) guestText = item.guestname;

        if (hostItem && hostValue) {
            if (hostText) {
                hostValue.innerHTML = hostText;
                hostItem.classList.remove("d-none");
            } else {
                hostItem.classList.add("d-none");
            }
        }
        if (guestItem && guestValue) {
            if (guestText) {
                guestValue.innerHTML = guestText;
                guestItem.classList.remove("d-none");
            } else {
                guestItem.classList.add("d-none");
            }
        }
        if (credits) {
            if (hostText || guestText) credits.classList.remove("d-none");
            else credits.classList.add("d-none");
        }
    }

    private loadRecommendations(): void {
        if (this.loaded) return;
        this.loaded = true;
        const component = this;

        if (window.Visitor && (window.Visitor.isbot || window.Visitor.type === "DC")) return;

        let primaryspecname = component.primarySpecialtyName;
        let primarysubspec = component.primarySubSpecialtyId;
        if (!primaryspecname || primaryspecname === "") primaryspecname = "na";
        if (!primarysubspec || primarysubspec === "") primarysubspec = "na";
        primaryspecname = primaryspecname.replace(/&#39;/g, "");
        primaryspecname = primaryspecname.replace(/ &/g, "");

        $.ajax({
            type: "GET",
            url: component.hwsHost + "/~/hws/relatedchips/" + component.cleanArticleId + "/podcast/" + primaryspecname + "/" + primarysubspec,
            success: function (msg: any): void {
                const relatedItems: RelatedItem[] = msg?.response?.relatedItems || [];
                const currentPath = component.normalizeUrl(window.location.pathname);
                const deduped = relatedItems.filter((x: RelatedItem) => component.normalizeUrl(x.url) !== currentPath).slice(0, 2);
                if (!deduped.length) return;

                deduped.forEach((item, idx) => {
                    const cardElem = document.getElementById("ymalCard" + (idx + 1));
                    if (!cardElem) return;
                    const postedDate = new Date(item.posteddate);
                    const formattedPostedDate = postedDate.toLocaleString("en-US", { day: "numeric", month: "long", year: "numeric" });
                    (cardElem.querySelector(".podcast-episode-card__date") as HTMLElement).innerHTML = formattedPostedDate;
                    (cardElem.querySelector(".podcast-episode-card__title") as HTMLElement).innerHTML = item.title;
                    (cardElem.querySelector(".podcast-episode-card__duration") as HTMLElement).innerHTML = (item.engagementtime || 0) + " min";
                    cardElem.setAttribute("href", item.url.toString().replace(PodcastYouMayAlsoLikeDiscoverability.healioUrl, ""));

                    const saveElem = cardElem.querySelector(".save.save--inline") as HTMLElement;
                    if (saveElem) {
                        saveElem.setAttribute("data-activity-id", item.url.replace("/find/", "").replace(/[{}]/g, ""));
                        saveElem.setAttribute("data-activity-title", item.title || "");
                        saveElem.setAttribute("data-activity-url", item.url.toString().replace(PodcastYouMayAlsoLikeDiscoverability.healioUrl, ""));
                    }

                    const imgElem = cardElem.querySelector(".podcast-episode-card__media img") as HTMLImageElement;
                    const imageSrc = component.getThumbnailUrl(item);
                    if (imgElem) {
                        if (imageSrc) {
                            imgElem.src = imageSrc;
                            imgElem.alt = item.title || "";
                            imgElem.classList.remove("d-none");
                        } else {
                            imgElem.classList.add("d-none");
                        }
                    }

                    component.populateCredits(cardElem, item);

                    const videoElem = cardElem.querySelector(".podcast-episode-card__video") as HTMLElement;
                    if (videoElem) {
                        if (item.video && item.video !== "") videoElem.classList.remove("d-none");
                        else videoElem.classList.add("d-none");
                    }

                    cardElem.classList.remove("d-none");
                });

                document.getElementById("podcastYouMayAlsoLike")?.classList.remove("d-none");
            },
            error: function (): void {
                console.error("Error loading Podcast You May Also Like");
            },
            timeout: 5000
        });
    }
}

ComponentFactory.registerComponent("PodcastYouMayAlsoLikeDiscoverability", PodcastYouMayAlsoLikeDiscoverability);
